/**
 * @Description File description.
 * @FileName moduleConstants.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 25 January, 2021 08:39:44
 * @IssueID - 311
 */
/**
   * All the route constants for the module
   */
const ROUTE_HOME = '/reports';
export const routeConstant = {
  REP_HOME_ROUTE: `${ROUTE_HOME}/home`,
  PROD_SUMMARY_ROUTE: `${ROUTE_HOME}/prodSummary`,
  BAL_SUMMARY_ROUTE: `${ROUTE_HOME}/balSummary`,
  REP_REPOSITORY_ROUTE: `${ROUTE_HOME}/reportRepository`,
  REP_REPOSITORY_EXT_ROUTE: `${ROUTE_HOME}/reportRepositoryExt`,
  COMP_STATEMENT_ROUTE: `${ROUTE_HOME}/compStatement`,
  REPORT_CENTER_ROUTE: `${ROUTE_HOME}/repcenter`,
  TEMPLATE_ROUTE: `${ROUTE_HOME}/repcenter/template`,
  // COMMISSION_FEED_ROUTE: `${ROUTE_HOME}/commisioFeed`,
  INTERACTIVE_ACTIVITY_REPORT_ROUTE: `${ROUTE_HOME}/interactiveAcitvityReports`,
  COMMISSION_FEED_ROUTE: `${ROUTE_HOME}/commisionfeed`,
  SS_REPORT_CENTER_ROUTE: `${ROUTE_HOME}/reports/repcenter`,
};

/**
   * ACL keys for the module
   */
export const aclKeysConstant = {
  ADMIN_MENU: 'RBAC_ADMINISTRATION',
  RBAC_REPORTS: 'RBAC_REPORTS',
  RBAC_REP_PRODUCTION_SUMMARY: 'RBAC_REP_PRODUCTION_SUMMARY',
  RBAC_REP_BALANCE_SUMMARY: 'RBAC_REP_BALANCE_SUMMARY',
  RBAC_PS_MENU: 'RBAC_PSU_MENU',
  RBAC_PS_EXPORT: 'RBAC_PSU_EXPORT',
  RBAC_BLS_MENU: 'RBAC_BLS_MENU',
  RBAC_BLS_EXPORT: 'RBAC_BLS_EXPORT',
  PRODUCTION_SUMMARY_MENU: 'RBAC_PSU_MENU',
  BALANCE_SUMMARY_MENU: 'RBAC_BLS_MENU',

  RBAC_CSR_MENU: 'RBAC_CSR_MENU',
  RBAC_CSR_DOWNLOAD_SELECTED: 'RBAC_CSR_DOWNLOAD_SELECTED',
  RBAC_CSR_PRINT: 'RBAC_CSR_PRINT',
  RBAC_CSR_VIEW: 'RBAC_CSR_VIEW',
  RBAC_CSR_EXPORT: 'RBAC_CSR_EXPORT',
  RBAC_COMP_STATEMENT: 'RBAC_COMP_STATEMENT',
  RBAC_CF_MENU: 'RBAC_CF_MENU',

  // Compensation statements
  RBAC_ECS_MENU: 'RBAC_ECS_MENU',
  RBAC_ECS_DOWNLOAD_SELECTED: 'RBAC_ECS_DOWNLOAD_SELECTED',
  RBAC_ECS_VIEW: 'RBAC_ECS_VIEW',
  RBAC_EXT_COMP_STATEMENT: 'RBAC_EXT_COMP_STATEMENT',
  COMPENSATION_STATEMENT_DASHBOARD_MENU: 'COMPENSATION_STATEMENT_DASHBOARD_MENU',
  RBAC_EXT_COMP_STATEMENT_DOWNLOAD: 'RBAC_EXT_COMP_STATEMENT_DOWNLOAD',
  // Interactive Activity Report
  RBAC_IAR_MENU: 'RBAC_IAR_MENU',
  RBAC_IAR_EXPORT: 'RBAC_IAR_EXPORT',

  RBAC_CMS_MENU: 'RBAC_CMS_MENU',
  RBAC_CMS_GENERATE_REPORT: 'RBAC_CMS_GENERATE_REPORT',

  // Self service
  RBAC_REP_CENTER_MENU: 'RBAC_REP_CENTER_MENU',
  RBAC_REP_CENTER_MENU_GENERATED_REP: 'RBAC_REP_CENTER_MENU_GENERATED_REP',
  RBAC_REP_CENTER_MENU_TEMPLATES: 'RBAC_REP_CENTER_MENU_TEMPLATES',
  RBAC_REP_CENTER_MENU_TEMPLATES_ADD: 'RBAC_REP_CENTER_MENU_TEMPLATES_ADD',
  RBAC_REP_CENTER_MENU_TEMPLATES_SHARE_REP: 'RBAC_REP_CENTER_MENU_TEMPLATES_SHARE_REP',
  RBAC_REP_CENTER_MENU_TEMPLATES_DEL_TEMPLATE: 'RBAC_REP_CENTER_MENU_TEMPLATES_DEL_TEMPLATE',
  RBAC_REP_CENTER_MENU_TEMPLATES_SCHDL_REP: 'RBAC_REP_CENTER_MENU_TEMPLATES_SCHDL_REP',
  RBAC_REP_CENTER_MENU_GENERATED_REP_SHARE_REP: 'RBAC_REP_CENTER_MENU_GENERATED_REP_SHARE_REP',
  RBAC_REP_CENTER_MENU_GENERATED_REP_DELETE_REP: 'RBAC_REP_CENTER_MENU_GENERATED_REP_DELETE_REP',
  RBAC_REP_CENTER_MENU_GENERATED_REP_DOWNLOAD_REP: 'RBAC_REP_CENTER_MENU_GENERATED_REP_DOWNLOAD_REP',
  RBAC_REP_CENTER_MENU_TEMPLATES_GEN_REP: 'RBAC_REP_CENTER_MENU_TEMPLATES_GEN_REP',

};

/**
   * i18n Keys for the module
   */
export const staticLabelKeys = {
  REPORT_MENU: 'RBAC_REPORTS',
  REP_PRODUCTION_SUMMARY: 'REP_PRODUCTION_SUMMARY',
  REP_BALANCE_SUMMARY: 'REP_BALANCE_SUMMARY',
  PRODSUM_PAGE_TITLE: 'PRODSUM_PAGE_TITLE',
  PRODSUM_LABEL_MSC: 'PRODSUM_LABEL_MSC',
  PRODSUM_LABEL_BFN: 'PRODSUM_LABEL_BFN',
  PRODSUM_LABEL_BLN: 'PRODSUM_LABEL_BLN',
  PRODSUM_LABEL_PAYEE: 'PRODSUM_LABEL_PAYEE',
  PRODSUM_LABEL_FFT: 'PRODSUM_LABEL_FFT',
  PRODSUM_LABEL_COMP: 'PRODSUM_LABEL_COMP',
  PRODSUM_LABEL_FFS: 'PRODSUM_LABEL_FFS',
  PRODSUM_LABEL_STATUSDT: 'PRODSUM_LABEL_STATUSDT',
  PRODSUM_LABEL_CONTRACTDT: 'PRODSUM_LABEL_CONTRACTDT',
  PRODSUM_LABEL_TERMINATIONDT: 'PRODSUM_LABEL_TERMINATIONDT',
  PRODSUM_LABEL_ACTIVEREC: 'PRODSUM_LABEL_ACTIVEREC',
  PRODSUM_LABEL_AFFILIATE: 'PRODSUM_LABEL_AFFILIATE',
  PRODSUM_LABEL_CORPORATION: 'PRODSUM_LABEL_CORPORATION',
  PRODSUM_LABEL_TEMPLEV: 'PRODSUM_LABEL_TEMPLEV',
  PRODSUM_LABEL_ALTERNATE: 'PRODSUM_LABEL_ALTERNATE',
  PRODSUM_LABEL_EFFECTIVEDT: 'PRODSUM_LABEL_EFFECTIVEDT',
  PRODSUM_LABEL_MOVEMENTDT: 'PRODSUM_LABEL_MOVEMENTDT',
  PRODSUM_LABEL_FYC_GROSS: 'PRODSUM_LABEL_FYC_GROSS',
  PRODSUM_LABEL_FYC_GROSS_YTD: 'PRODSUM_LABEL_FYC_GROSS_YTD',
  PRODSUM_LABEL_FYC: 'PRODSUM_LABEL_FYC',
  PRODSUM_LABEL_FYCYTD: 'PRODSUM_LABEL_FYCYTD',
  PRODSUM_LABEL_FYO: 'PRODSUM_LABEL_FYO',
  PRODSUM_LABEL_FYOYTD: 'PRODSUM_LABEL_FYOYTD',
  PRODSUM_LABEL_FYC_CHARGE: 'PRODSUM_LABEL_FYC_CHARGE',
  PRODSUM_LABEL_FYC_CHARGE_YTD: 'PRODSUM_LABEL_FYC_CHARGE_YTD',
  PRODSUM_LABEL_FYO_CHARGE: 'PRODSUM_LABEL_FYO_CHARGE',
  PRODSUM_LABEL_FYO_CHARGE_YTD: 'PRODSUM_LABEL_FYO_CHARGE_YTD',
  PRODSUM_LABEL_FYC_COMMISSION: 'PRODSUM_LABEL_FYC_COMMISSION',
  PRODSUM_LABEL_FYC_COMMISSION_YTD: 'PRODSUM_LABEL_FYC_COMMISSION_YTD',
  PRODSUM_LABEL_POLICY: 'PRODSUM_LABEL_POLICY',
  PRODSUM_LABEL_POLICY_YTD: 'PRODSUM_LABEL_POLICY_YTD',
  PRODSUM_LABEL_REN: 'PRODSUM_LABEL_REN',
  PRODSUM_LABEL_REN_YTD: 'PRODSUM_LABEL_REN_YTD',
  PRODSUM_LABEL_RENEWAL_COMM: 'PRODSUM_LABEL_RENEWAL_COMM',
  PRODSUM_LABEL_RENEWAL_COMM_YTD: 'PRODSUM_LABEL_RENEWAL_COMM_YTD',
  PRODSUM_LABEL_RENEWAL: 'PRODSUM_LABEL_RENEWAL',
  PRODSUM_LABEL_RENEWAL_YTD: 'PRODSUM_LABEL_RENEWAL_YTD',
  PRODSUM_LABEL_RENEWAL_PREM: 'PRODSUM_LABEL_RENEWAL_PREM',
  PRODSUM_LABEL_SALES: 'PRODSUM_LABEL_SALES',
  PRODSUM_LABEL_SALES_YTD: 'PRODSUM_LABEL_SALES_YTD',
  PRODSUM_LABEL_PERSISTENCY: 'PRODSUM_LABEL_PERSISTENCY',
  PRODSUM_LABEL_REFERRAL: 'PRODSUM_LABEL_REFERRAL',
  PRODSUM_LABEL_REFERRAL_YTD: 'PRODSUM_LABEL_REFERRAL_YTD',
  PRODSUM_LABEL_REFERRAL_GROSS: 'PRODSUM_LABEL_REFERRAL_GROSS',
  PRODSUM_LABEL_REFERRAL_GROSS_YTD: 'PRODSUM_LABEL_REFERRAL_GROSS_YTD',
  PRODSUM_LABEL_EQUALIZED: 'PRODSUM_LABEL_EQUALIZED',
  PRODSUM_LABEL_EQUALIZED_YTD: 'PRODSUM_LABEL_EQUALIZED_YTD',
  PRODSUM_LABEL_EQUALIZED_OVERRIDE: 'PRODSUM_LABEL_EQUALIZED_OVERRIDE',
  PRODSUM_LABEL_EQUALIZED_OVERRIDE_YTD: 'PRODSUM_LABEL_EQUALIZED_OVERRIDE_YTD',
  PRODSUM_LABEL_PERSISTENCY_LAPSES: 'PRODSUM_LABEL_PERSISTENCY_LAPSES',
  PRODSUM_LABEL_EXPORT_MOD_TITLE: 'PRODSUM_LABEL_EXPORT_MOD_TITLE',
  BLS_LABEL_EXPORT_MOD_TITLE: 'BLS_LABEL_EXPORT_MOD_TITLE',
  BLS_PAGE_TITLE: 'BLS_PAGE_TITLE',
  BLS_LABEL_COMP_SCH: 'BLS_LABEL_COMP_SCH',
  BLS_LABEL_FF_STATUS: 'BLS_LABEL_FF_STATUS',
  BLS_LABEL_TYPE: 'BLS_LABEL_TYPE',
  BLS_LABEL_BAL_FORWARD: 'BLS_LABEL_BAL_FORWARD',
  BLS_LABEL_CURR_BAL: 'BLS_LABEL_CURR_BAL',
  BLS_LABEL_WRITEOFF: 'BLS_LABEL_WRITEOFF',
  BLS_LABEL_WRITEOFF_OV: 'BLS_LABEL_WRITEOFF_OV',
  BLS_LABEL_WRITEOFF_AMT: 'BLS_LABEL_WRITEOFF_AMT',
  BLS_LABEL_WRITEOFF_AMT_OV: 'BLS_LABEL_WRITEOFF_AMT_OV',
  BLS_LABEL_RESCAP_ACCFW: 'BLS_LABEL_RESCAP_ACCFW',
  BLS_LABEL_RESCAP_ACCYTD: 'BLS_LABEL_RESCAP_ACCYTD',
  BLS_LABEL_ROLL_DEB_FW: 'BLS_LABEL_ROLL_DEB_FW',
  BLS_LABEL_ROLL_DEB_BAL: 'BLS_LABEL_ROLL_DEB_BAL',
  BLS_LABEL_MAX_DEB_ALLW: 'BLS_LABEL_MAX_DEB_ALLW',
  BLS_LABEL_MAXDEBALLW_EXP_DT: 'BLS_LABEL_MAXDEBALLW_EXP_DT',
  BLS_LABEL_REN_OV: 'BLS_LABEL_REN_OV',
  BLS_LABEL_DEDC: 'BLS_LABEL_DEDC',
  BLS_LABEL_MSC_ADJ: 'BLS_LABEL_MSC_ADJ',
  BLS_LABEL_TRANS: 'BLS_LABEL_TRANS',
  BLS_LABEL_PYMT: 'BLS_LABEL_PYMT',
  BLS_LABEL_RES_CAP: 'BLS_LABEL_RES_CAP',
  BLS_LABEL_ROLL_DEB_TRANS: 'BLS_LABEL_ROLL_DEB_TRANS',
  BLS_LABEL_TAX_EAR: 'BLS_LABEL_TAX_EAR',
  BLS_LABEL_TAX_BEN: 'BLS_LABEL_TAX_BEN',
  BLS_LABEL_MDRT: 'BLS_LABEL_MDRT',
  BLS_LABEL_REN_OV_YTD: 'BLS_LABEL_REN_OV_YTD',
  BLS_LABEL_DEDC_YTD: 'BLS_LABEL_DEDC_YTD',
  BLS_LABEL_MSC_ADJ_YTD: 'BLS_LABEL_MSC_ADJ_YTD',
  BLS_LABEL_TRANS_YTD: 'BLS_LABEL_TRANS_YTD',
  BLS_LABEL_PYMT_YTD: 'BLS_LABEL_PYMT_YTD',
  BLS_LABEL_RES_CAP_ACC_BAL: 'BLS_LABEL_RES_CAP_ACC_BAL',
  BLS_LABEL_DEB_TRANS_YTD: 'BLS_LABEL_DEB_TRANS_YTD',
  BLS_LABEL_TAX_BEN_YTD: 'BLS_LABEL_TAX_BEN_YTD',
  BLS_LABEL_TAX_EAR_YTD: 'BLS_LABEL_TAX_EAR_YTD',
  BLS_LABEL_MDRT_YTD: 'BLS_LABEL_MDRT_YTD',
  BLS_LABEL_DET_REC_CNT: 'BLS_LABEL_DET_REC_CNT',
  BLS_LABEL_PER_ID: 'BLS_LABEL_PER_ID',
  BLS_LABEL_PYMT_MTH: 'BLS_LABEL_PYMT_MTH',
  BLS_LABEL_BANK_NO: 'BLS_LABEL_BANK_NO',
  BLS_LABEL_BRCH_NO: 'BLS_LABEL_BRCH_NO',
  BLS_LABEL_ACCNO: 'BLS_LABEL_ACCNO',
  BLS_LABEL_TRANS_TO: 'BLS_LABEL_TRANS_TO',
  BLS_LABEL_PYMT_STAT: 'BLS_LABEL_PYMT_STAT',
  BLS_LABEL_TAXFRM: 'BLS_LABEL_TAXFRM',
  BLS_LABEL_INS_ADV: 'BLS_LABEL_INS_ADV',
  BLS_LABEL_INS_AFF: 'BLS_LABEL_INS_AFF',
  BLS_LABEL_INS_CORP: 'BLS_LABEL_INS_CORP',
  BLS_LABEL_INS_TEMP: 'BLS_LABEL_INS_TEMP',
  BLS_LABEL_INS_LOC: 'BLS_LABEL_INS_LOC',
  BLS_LABEL_INS_ALT: 'BLS_LABEL_INS_ALT',
  BLS_LABEL_INS_DIST: 'BLS_LABEL_INS_DIST',
  BLS_LABEL_INS_REG: 'BLS_LABEL_INS_REG',
  BLS_LABEL_INS_CHA: 'BLS_LABEL_INS_CHA',
  BLS_LABEL_INS_COM: 'BLS_LABEL_INS_COM',
  BLS_LABEL_NEG_DEB: 'BLS_LABEL_NEG_DEB',
  BLS_LABEL_NEG_DEB_FWD: 'BLS_LABEL_NEG_DEB_FWD',
  BLS_LABEL_NEG_DEB_TRANS: 'BLS_LABEL_NEG_DEB_TRANS',
  BLS_LABEL_GRP_PORBAL: 'BLS_LABEL_GRP_PORBAL',
  BLS_LABEL_CB_DEB_STRTDT: 'BLS_LABEL_CB_DEB_STRTDT',
  BLS_LABEL_NEG_DEB_STRTDT: 'BLS_LABEL_NEG_DEB_STRTDT',

  REPR_PAGE_TITLE: 'REPR_PAGE_TITLE',
  REP_LABEL_LOCATIONLEVEL: 'REP_LABEL_LOCATIONLEVEL',
  REP_LABEL_LOCATIONID: 'REP_LABEL_LOCATIONID',
  REP_LABEL_REPSTARTDT: 'REP_LABEL_REPSTARTDT',
  REP_LABEL_REPENDDT: 'REP_LABEL_REPENDDT',
  REP_LABEL_TASK: 'REP_LABEL_TASK',
  REP_LABEL_REPTITLE: 'REP_LABEL_REPTITLE',
  REP_LABEL_PHYFILEPATH: 'REP_LABEL_PHYFILEPATH',
  REP_LABEL_FILESIZE: 'REP_LABEL_FILESIZE',
  /* REP_LABEL_AVAILABLEWEB: 'REP_LABEL_AVAILABLEWEB',
  REP_LABEL_REPPAGES: 'REP_LABEL_REPPAGES',
  REP_LABEL_DET1: 'REP_LABEL_DET1',
  REP_LABEL_DET2: 'REP_LABEL_DET2',
  REP_LABEL_DET3: 'REP_LABEL_DET3',
  REP_LABEL_DET4: 'REP_LABEL_DET4',
  REP_LABEL_DET5: 'REP_LABEL_DET5',
  REP_LABEL_DET6: 'REP_LABEL_DET6',
  REP_LABEL_DET7: 'REP_LABEL_DET7',
  REP_LABEL_DET8: 'REP_LABEL_DET8',
  REP_LABEL_DET9: 'REP_LABEL_DET9',
  REP_LABEL_DET10: 'REP_LABEL_DET10', */

  CSR_PAGE_TITLE: 'CSR_PAGE_TITLE',
  CSR_LABEL_NAME: 'CSR_LABEL_NAME',
  CSR_LABEL_TASK: 'CSR_LABEL_TASK',
  CSR_LABEL_REPORT_TITLE: 'CSR_LABEL_REPORT_TITLE',
  CSR_LABEL_PHYSICAL_FILE_PATH: 'CSR_LABEL_PHYSICAL_FILE_PATH',
  CSR_LABEL_FILE_SIZE: 'CSR_LABEL_FILE_SIZE',
  CSR_LABEL_DOCUMENT_ID: 'CSR_LABEL_DOCUMENT_ID',
  CSR_LABEL_DOWNLOAD_SELECTED: 'CSR_LABEL_DOWNLOAD_SELECTED',
  CSR_LABEL_PRINT: 'CSR_LABEL_PRINT',
  CSR_LABEL_REP_START_DT: 'CSR_LABEL_REP_START_DT',
  CSR_LABEL_REP_END_DT: 'CSR_LABEL_REP_END_DT',
  CSR_WARN_DISCLAIM: 'CSR_WARN_DISCLAIM',

  CSR_PAGE_TITLE_EXT: 'CSR_PAGE_TITLE_EXT',
  CSR_LABEL_SEARCH_OPTIONS: 'CSR_LABEL_SEARCH_OPTIONS',
  CSR_LABEL_QUICK_SEARCH: 'CSR_LABEL_QUICK_SEARCH',
  CSR_LABEL_ADV_SEARCH: 'CSR_LABEL_ADV_SEARCH',
  CSR_LABEL_VIEW: 'CSR_LABEL_VIEW',
  CSR_LABEL_ORG_LEVEL: 'CSR_LABEL_ORG_LEVEL',
  CSR_LABEL_DISP_LAST: 'CSR_LABEL_DISP_LAST',
  CSR_LABEL_DISP_REPORTS: 'CSR_LABEL_DISP_REPORTS',
  CSR_LABEL_CLEAR_RESULTS: 'CSR_LABEL_CLEAR_RESULTS',
  CSR_LABEL_LAST_OR_COMP_NAME: 'CSR_LABEL_LAST_OR_COMP_NAME',

  CSR_PAGE_TITLE_DASHBOARD: 'CSR_PAGE_TITLE_DASHBOARD',
  CSR_LABEL_VIEW_ALL: 'CSR_LABEL_VIEW_ALL',
  CSR_LABEL_SHOW_RECENT: 'CSR_LABEL_SHOW_RECENT',

  IAR_LABEL_IAR_TITLE: 'IAR_LABEL_IAR_TITLE',
  IAR_LABEL_SHOW_CURR_PERIOD: 'IAR_LABEL_SHOW_CURR_PERIOD',
  IAR_LABEL_CLIENT_NAME: 'IAR_LABEL_CLIENT_NAME',
  IAR_LABEL_ACTIVITY_PERIOD: 'IAR_LABEL_ACTIVITY_PERIOD',
  IAR_LABEL_EXPORT: 'IAR_LABEL_EXPORT',
  IAR_LABEL_COMP_TYPE: 'IAR_LABEL_COMP_TYPE',
  IAR_LABEL_ACTIVITY_PERIOD_WEEK: 'IAR_LABEL_ACTIVITY_PERIOD_WEEK',
  IAR_LABEL_COMPENSATION_TYPES: 'IAR_LABEL_COMPENSATION_TYPES',
  IAR_LABEL_MANULIFE_SEELING_CODES: 'IAR_LABEL_MANULIFE_SEELING_CODES',
  IAR_LABEL_TAB_CONTENT: 'IAR_LABEL_TAB_CONTENT',
  IAR_LABEL_PERIOD_AMOUNT: 'IAR_LABEL_PERIOD_AMOUNT',
  IAR_LABEL_ADJUSTED_MONTH_AMOUNT: 'IAR_LABEL_ADJUSTED_MONTH_AMOUNT',
  IAR_LABEL_YTD_AMOUNT: 'IAR_LABEL_YTD_AMOUNT',
  IAR_LABEL_SELLING_CODE_NAME: 'IAR_LABEL_SELLING_CODE_NAME',
  IAR_LABEL_FROM_TO_PRODUCER: 'IAR_LABEL_FROM_TO_PRODUCER',
  IAR_LABEL_PLAN_NAME: 'IAR_LABEL_PLAN_NAME',
  IAR_LABEL_TRANSACTION_TYPE: 'IAR_LABEL_TRANSACTION_TYPE',
  IAR_LABEL_COMP_BASE: 'IAR_LABEL_COMP_BASE',
  IAR_LABEL_SHARE_PER: 'IAR_LABEL_SHARE_PER',
  IAR_LABEL_RATE_PER: 'IAR_LABEL_RATE_PER',
  IAR_LABEL_COMP_AMOUNT: 'IAR_LABEL_COMP_AMOUNT',
  IAR_MSG_FOR_HEADING: 'IAR_MSG_FOR_HEADING',
  IAR_MSG_NO_RECORD_FOUND: 'COMMON_LABEL_NO_RECORD_FOUND',

  CMFD_TITLE_COMM_FEED: 'CMFD_TITLE_COMM_FEED',
  CMFD_LABEL_PRD_MNTH: 'CMFD_LABEL_PRD_MNTH',
  CMFD_LABEL_INCLD_COMM: 'CMFD_LABEL_INCLD_COMM',
  CMFD_LABEL_INCLD_APCNT: 'CMFD_LABEL_INCLD_APCNT',
  CMFD_LABEL_INCLD_OVRD: 'CMFD_LABEL_INCLD_OVRD',
  CMFD_LABEL_INCLD_OTHR: 'CMFD_LABEL_INCLD_OTHR',
  CMFD_LABEL_FILE_PATH: 'CMFD_LABEL_FILE_PATH',
  CMFD_BUTTON_GEN_REQ: 'CMFD_BUTTON_GEN_REQ',
  CMFD_LABEL_XML_MAP: 'CMFD_LABEL_XML_MAP',
  CF_SUCCESS: 'CF_SUCCESS',
  CF_FAIL: 'CF_FAIL',

  CMS_PAGE_TITLE: 'RBAC_CMS_MENU',
  CMS_PERIOD_ACTIVE: 'CMS_PERIOD_ACTIVE',
  CMS_PERIOD_CURRENT: 'CMS_PERIOD_CURRENT',
  CMS_GENERATE_REPORT: 'CMS_GENERATE_REPORT',
  // Self Service
  SS_HELPTEXT_LABEL: 'SS_HELPTEXT_LABEL',
  COMMON_LABEL_MLC_WEALTH_CODE: 'COMMON_LABEL_MLC_WEALTH_CODE',
  REPORT_TEMPLATE_ADD_SUCCESS: 'REPORT_TEMPLATE_ADD_SUCCESS',
  REPORT_TEMPLATE_UPDATE_SUCCESS: 'REPORT_TEMPLATE_UPDATE_SUCCESS',

  RT_DEL_SHARED_WITH_ME_MSG: 'RT_DEL_SHARED_WITH_ME_MSG',
  RT_DEL_SHARED_BY_ME_MSG: 'RT_DEL_SHARED_BY_ME_MSG',
  RT_DEL_CONFIRM_MSG: 'TA_DELETE_PROCEED_CONFIRMATION',
  RT_DEL_SUCCESS_MSG: 'RT_DEL_SUCCESS_MSG',
  GT_DEL_SUCCESS_MSG: 'GT_DEL_SUCCESS_MSG',

  SHARE_REPORT_TITLE: 'SHARE_REPORT_TITLE',
  SHARE_REPORT_INFO: 'SHARE_REPORT_INFO',
  SHARE_REPORT_USERNAME_LABEL: 'SHARE_REPORT_USERNAME_LABEL',
  SHARE_REPORT_USERNAME_INFO: 'SHARE_REPORT_USERNAME_INFO',
  SHARE_REPORT_TEMPLATE_SUCCESS: 'SHARE_REPORT_TEMPLATE_SUCCESS',
  SHARED_TEMPLATE_DUPLICATE_ERR: 'SHARED_TEMPLATE_DUPLICATE_ERR',

  SHARE_GENERATED_REPORT_TITLE: 'SHARE_GENERATED_REPORT_TITLE',
  SHARE_GENERATED_REPORT_INFO: 'SHARE_GENERATED_REPORT_INFO',
  SHARE_GENERATED_REPORT_SUCCESS: 'SHARE_GENERATED_REPORT_SUCCESS',

  SHARE_REPORT_SCHEDULE_SUCCESS: 'SHARE_REPORT_SCHEDULE_SUCCESS',

  SS_LABEL_SCHEDULE_STATUS: 'SS_LABEL_SCHEDULE_STATUS',
  SS_LABEL_REP_GEN_TIME: 'SS_LABEL_REP_GEN_TIME',
  SS_REP_GEN_TIME_MSG: 'SS_REP_GEN_TIME_MSG',

  RT_SCHEDULE_TITLE: 'RT_SCHEDULE_TITLE',
  RT_SCHEDULE_INFO: 'RT_SCHEDULE_INFO',
  SS_REP_GEN_DEL_SUCCESS: 'SS_REP_GEN_DEL_SUCCESS',
  SS_REP_GEN_DEL_INFO: 'SS_REP_GEN_DEL_INFO',

  SS_LABEL_REPORT_CENTER_TITLE: 'SS_LABEL_REPORT_CENTER_TITLE',
  SS_LABEL_REPORT_TEMPLATES_TAB: 'SS_LABEL_REPORT_TEMPLATES_TAB',
  SS_LABEL_GENERATED_REPORTS_TAB: 'SS_LABEL_GENERATED_REPORTS_TAB',
  SS_REPORTS_TEMPLATES_COLUMN_NAME: 'SS_REPORTS_TEMPLATES_COLUMN_NAME',
  COMMON_LABEL_DESCRIPTION: 'SS_COMMON_LABEL_DESCRIPTION',
  COMMON_LABEL_SHARED_ON: 'SS_COMMON_LABEL_SHARED_ON',
  COMMON_LABEL_ACTIONS: 'SS_COMMON_LABEL_ACTIONS',
  SS_LABEL_NEW_REPORT_TEMPLATE: 'SS_LABEL_NEW_REPORT_TEMPLATE',
  SS_DATA_LABEL_CRITERIA: 'SS_DATA_LABEL_CRITERIA',
  SS_SELECT_DATA_REPORT: 'SS_SELECT_DATA_REPORT',
  SS_DATA_LABEL_SOURCE: 'SS_DATA_LABEL_SOURCE',
  SS_LABEL_DISPLAY_NAME: 'SS_LABEL_DISPLAY_NAME',
  SS_LABEL_UPDATE_COLUMN_NAME: 'SS_LABEL_UPDATE_COLUMN_NAME',
  SS_LABEL_COLUMN_NAME: 'SS_LABEL_COLUMN_NAME',
  SS_LABEL_REPORT_OUTPUT: 'SS_LABEL_REPORT_OUTPUT',
  SS_REVIEW_AND_WORK_FORMATS: 'SS_REVIEW_AND_WORK_FORMATS',
  SS_REPORT_FREQUENCY_MSG_DAILY: 'SS_REPORT_FREQUENCY_MSG_DAILY',
  SS_REPORT_FREQUENCY_MSG_PERIOD_END: 'SS_REPORT_FREQUENCY_MSG_PERIOD_END',
  SS_REPORT_FREQUENCY_MSG_MONTH_END: 'SS_REPORT_FREQUENCY_MSG_MONTH_END',
  SS_REPORT_FREQUENCY_MSG_ADJUSTED_MONTH_END: 'SS_REPORT_FREQUENCY_MSG_ADJUSTED_MONTH_END',
  SS_REPORT_FREQUENCY_MSG_QUARTER_END: 'SS_REPORT_FREQUENCY_MSG_QUARTER_END',
  SS_REPORT_FREQUENCY_MSG_YEAR_END: 'SS_REPORT_FREQUENCY_MSG_YEAR_END',
  SS_SR_LABEL_SHARED_REPORT: 'SS_SR_LABEL_SHARED_REPORT',
  SR_LABEL_GROUP: 'SR_LABEL_GROUP',
  SS_GR_LABEL_REPORT_DATE: 'SS_GR_LABEL_REPORT_DATE',
  SS_LABEL_BUTTON_PREVIEW_TEMPLATE: 'SS_LABEL_BUTTON_PREVIEW_TEMPLATE',
  SS_LABEL_BUTTON_SAVE_TEMPLATE: 'SS_LABEL_BUTTON_SAVE_TEMPLATE',
  SS_REPORT_FREQUENCY_DAILY: 'SS_REPORT_FREQUENCY_DAILY',
  SS_REPORT_FREQUENCY_PERIOD_END: 'SS_REPORT_FREQUENCY_PERIOD_END',
  SS_REPORT_FREQUENCY_MONTH_END: 'SS_REPORT_FREQUENCY_MONTH_END',
  SS_REPORT_FREQUENCY_ADJUSTED_MONTH_END: 'SS_REPORT_FREQUENCY_ADJUSTED_MONTH_END',
  SS_REPORT_FREQUENCY_QUARTER_END: 'SS_REPORT_FREQUENCY_QUARTER_END',
  SS_REPORT_FREQUENCY_YEAR_END: 'SS_REPORT_FREQUENCY_YEAR_END',
  SS_LABEL_SCHEDULE_DETAILS: 'SS_LABEL_SCHEDULE_DETAILS',
  SS_LABEL_RECURRENCE: 'SS_LABEL_RECURRENCE',
  SS_LABEL_GROUP: 'SS_LABEL_GROUP',
  SS_LABEL_EDIT_REPORT_TEMPLATE: 'SS_LABEL_EDIT_REPORT_TEMPLATE',
  SS_GR_LABEL_GENERATED_BY: 'SS_GR_LABEL_GENERATED_BY',
  SS_GR_LABEL_GENERATION_STATUS: 'SS_GR_LABEL_GENERATION_STATUS',
  // CTFSLCAC-4428: RBAC error message when all columns are filtered out
  FILTER_VISIBILITY_NO_COLS_SELECTED_MSG: 'FILTER_VISIBILITY_NO_COLS_SELECTED_MSG',
  // CTFSLCAC-4361: RBAC error message when datasource access is denied
  SS_DATASOURCE_ACCESS_DENIED: 'SS_DATASOURCE_ACCESS_DENIED',
  // CTFSLCAC-4428: RBAC error message when field access is denied (criteria/sort/groupBy)
  SS_FIELD_ACCESS_DENIED: 'SS_DATASOURCE_ACCESS_DENIED',
  // Dynamic-date
  SS_LABEL_STATIC_DATE: 'SS_LABEL_STATIC_DATE',
  SS_LABEL_DYNAMIC_DATE: 'SS_LABEL_DYNAMIC_DATE',
  SS_HELPTEXT_LABEL_DYNAMIC_DATE: 'SS_HELPTEXT_LABEL_DYNAMIC_DATE',
  SS_LABEL_CURRENT_FREQUENCY_START_DATE: 'SS_LABEL_CURRENT_FREQUENCY_START_DATE',
  SS_LABEL_CURRENT_FREQUENCY_END_DATE: 'SS_LABEL_CURRENT_FREQUENCY_END_DATE',
};
